import { faFileExport, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "../ui/button";

interface PageHeaderProps {
  title: string;
  exportLabel: string;
  addLabel: string;
  exportEnabled?: boolean;
  onExport: () => void;
  onAdd: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  exportLabel,
  exportEnabled = true,
  addLabel,
  onExport,
  onAdd,
}) => {
  return (
    <div className="mb-4 flex flex-col justify-between gap-3 lg:flex-row lg:items-center">
      <h1 className="text-xl font-semibold lg:text-2xl">{title}</h1>
      <div className="flex space-x-3">
        {exportEnabled && (
          <Button onClick={onExport} variant="secondary">
            <FontAwesomeIcon icon={faFileExport} className="mr-2" />
            {exportLabel}
          </Button>
        )}
        <Button onClick={onAdd}>
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          {addLabel}
        </Button>
      </div>
    </div>
  );
};

export default PageHeader;
